import { api } from '@/services/api/main/axios';

export type AffiliateNetworkListItem = {
  id: string;
  name: string;
  workspaceId: string;
  templateId?: string;
  affiliateNetworkTemplate?: Record<string, unknown>;
};

export const getAffiliateNetworksApiRequest = async (): Promise<AffiliateNetworkListItem[]> => {
  const res = await api.get<{ payload: AffiliateNetworkListItem[] }>('affiliate-networks', {
    params: {
      status: 'active',
      columns: ['id', 'name', 'workspaceId', 'templateId'],
      orderBy: 'updated',
      orderDirection: 'desc',
    },
  });
  return res.data.payload;
};

export const getAffiliateNetworkApiRequest = async (
  id: string,
): Promise<AffiliateNetworkListItem & Record<string, unknown>> => {
  const res = await api.get<{ payload: AffiliateNetworkListItem & Record<string, unknown> }>(
    `affiliate-networks/${id}`,
  );
  return res.data.payload;
};

export const getAffiliateNetworksListApiRequest = async (
  params: Record<string, unknown> = {},
): Promise<AffiliateNetworkListItem[]> => {
  const res = await api.get<{ payload: AffiliateNetworkListItem[] }>('affiliate-networks', {
    params,
  });
  return res.data.payload;
};

export const postCreateAffiliateNetworkApiRequest = async (
  payload: object,
): Promise<Record<string, unknown>> => {
  const res = await api.post<{ payload: Record<string, unknown> }>('affiliate-networks', payload);
  return res.data.payload;
};

export const putUpdateAffiliateNetworkApiRequest = async (
  id: string,
  payload: object,
): Promise<Record<string, unknown>> => {
  const res = await api.put<{ payload: Record<string, unknown> }>(
    `affiliate-networks/${id}`,
    payload,
  );
  return res.data.payload;
};

export const getAffiliateNetworkTemplatesApiRequest = async (): Promise<unknown[]> => {
  const res = await api.get<{ payload: unknown[] }>('affiliate-networks-templates');
  return res.data.payload;
};

export const getAffiliateNetworksCountApiRequest = async (
  params: Record<string, unknown> = {},
): Promise<{ count: number }> => {
  const res = await api.get<{ payload: { count: number } }>('affiliate-networks/count', { params });
  return res.data.payload;
};
